import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"

// The trigger shared by the Find Freelancers filter bar's dropdowns. `has`
// darkens the border when the dropdown holds an applied filter. Radix passes
// `ref` and the open state through asChild; below 561px the three triggers
// share one row equally, so the chevron gives up its room.
export function BarButton({ has = false, chevron = true, className, children, ref, ...props }) {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        "group inline-flex items-center gap-[8px] rounded-[11px] border bg-card px-[14px] py-[11px] text-[13px] font-semibold whitespace-nowrap text-foreground transition-colors hover:border-line-2 data-[state=open]:border-foreground",
        "max-[561px]:min-w-0 max-[561px]:flex-1 max-[561px]:justify-center max-[561px]:gap-[5px] max-[561px]:px-[6px] max-[561px]:py-[10px]",
        has ? "border-muted-foreground" : "border-border",
        className
      )}
      {...props}
    >
      {children}
      {chevron && (
        <ChevronDown
          className="size-[15px] shrink-0 text-ink-3 transition-transform group-data-[state=open]:rotate-180 max-[561px]:hidden"
          strokeWidth={2}
        />
      )}
    </button>
  )
}

export function CountBadge({ n }) {
  return (
    <span className="inline-flex h-[19px] min-w-[19px] items-center justify-center rounded-full bg-foreground px-[6px] text-[11px] font-bold text-background">
      {n}
    </span>
  )
}
